<template>
  <div class="place"
       :style="'--place-color: ' + place.color + ';'"
      :class="{'active' : checkIsActive, 'selected': checkIsSelected}"
      @click="click">
    <div class="image" v-html="place.svgCode">
    </div>
    <div class="label-for-table">
      {{ place.name }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['place'],
  name: 'Place',
  computed: {
    checkIsSelected () {
      return this.$store.state.selectedPlaceSet.has(this.place.id)
    },
    checkIsActive () {
      if(this.$store.state.selectedStartDate){
        return this.$store.state.availablePlaceSet.has(this.place.id)
      }else{
        return true
      }
    }
  },
  methods: {
    click() {
      if (this.checkIsActive) {
        this.$emit('click', this.place.id)
        this.$store.dispatch('fetchNotAvailableDates')
      }
    }
  }
}
</script>

<style>
  .place {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .image {
    width: 100%;
    height: 100%;
  }
  .image > svg, .place {
    width: 100%;
    height: 100%;
  }
  .image > svg > path {
    fill: #D0D5DD;
    transition: .2s;
  }
  .place.active .image > svg > path {
    fill: #252525;
    cursor: pointer;
    transition: .2s;
  }
  .place.selected .image > svg > path {
    fill: var(--place-color);
    cursor: pointer;
    transition: .2s;
  }

  .label-for-table {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/Place.vue